import "./storibox.341d41b3.js";


      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire40f7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire40f7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $hMTg2 = parcelRequire("hMTg2");
const $c889b34800d09a44$export$69d25b90d0002cf3 = {
    valid_att_code: 'Please enter the code printed on the back of your StoriCard.',
    empty_album: 'Your album is empty.',
    valid_email: 'Please enter a valid e-mail address'
};
const $c889b34800d09a44$var$API_URL = "https://api-new.occo.io/v1";
const $c889b34800d09a44$var$OLD_WEBAPP = "https://events.occo.io/old-webapp.html";
const $c889b34800d09a44$var$PAYPAL_ACTIVE = true;
function $c889b34800d09a44$export$d5fafd96da807b8f(id) {
    return document.getElementById(id);
}
const $c889b34800d09a44$var$emailRegex = // eslint-disable-next-line no-useless-escape
/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // Email address
function $c889b34800d09a44$var$isEmail(email, multi) {
    let validEmail = true;
    if (multi) {
        const emails = email.split(',');
        if (emails && emails.length > 1) $.each(emails, (index, value)=>{
            if (!$c889b34800d09a44$var$emailRegex.test(value)) return false;
            return undefined;
        });
        else validEmail = $c889b34800d09a44$var$emailRegex.test(emails[0]);
    } else validEmail = $c889b34800d09a44$var$emailRegex.test(email);
    return validEmail;
}
function $c889b34800d09a44$export$34c5a9262f934fa5(variable) {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for(let i = 0; i < vars.length; i++){
        const pair = vars[i].split('=');
        if (pair[0] === variable) return pair[1];
    }
    return false;
}
function $c889b34800d09a44$var$attendeeValidation({ attendeeUid: attendeeUid, eventPrivateApiKey: eventPrivateApiKey }, callback) {
    if (eventPrivateApiKey) $.ajax({
        type: 'POST',
        url: `${$c889b34800d09a44$var$API_URL}/attendee/check-and-group-uid-list`,
        data: JSON.stringify({
            attendee_uid_list: [
                attendeeUid
            ],
            event_private_api_key: eventPrivateApiKey
        }),
        dataType: 'json',
        success (resp) {
            if (resp.result === true) $c889b34800d09a44$var$fetchAttendee(attendeeUid, callback);
            else callback({
                status: 'error',
                message: 'Invalid attendee code'
            });
        }
    });
    else $c889b34800d09a44$var$fetchAttendee(attendeeUid, callback);
}
function $c889b34800d09a44$var$fetchAttendee(attendeeUid, callback) {
    $.ajax({
        type: 'POST',
        url: `${$c889b34800d09a44$var$API_URL}/attendee/retrieve`,
        data: JSON.stringify({
            attendee_uid: attendeeUid
        }),
        dataType: 'json',
        success (resp) {
            callback(resp);
        }
    });
}
function $c889b34800d09a44$var$getEvent(attendeeUid, callback) {
    const data = {
        key_type: 'attendee_uid',
        key_value: attendeeUid
    };
    $.ajax({
        type: 'POST',
        url: `${$c889b34800d09a44$var$API_URL}/event/list/retrieve`,
        data: JSON.stringify(data),
        dataType: 'json',
        success (resp) {
            callback(resp);
        }
    });
}
function $c889b34800d09a44$var$partialUnlock(attendeeUid, eventPrivateApiKey, partialUnlockTag, callback) {
    const body = {
        attendee_uid: attendeeUid,
        event_private_api_key: eventPrivateApiKey,
        employee_secret_code: '',
        should_print: false,
        should_unlock: true,
        email_to_address: null,
        auth_required: true,
        phone_number: null,
        printer_pool_name: null,
        printable_photo_uid_array: null,
        price: null,
        payment_type: null,
        kioskId: null,
        partialUnlockTags: partialUnlockTag && partialUnlockTag !== 'undefined' ? partialUnlockTag : null,
        printing_count: 0
    };
    $.ajax({
        type: 'POST',
        url: `${$c889b34800d09a44$var$API_URL}/attendee/unlock-and-print`,
        data: JSON.stringify(body),
        dataType: 'json',
        success (resp) {
            callback(resp);
        }
    });
}
function $c889b34800d09a44$var$updateAttendee(attendee_uid, email, name, event_name, app_url, callback) {
    const data = {
        attendee_uid: attendee_uid,
        email_address: email,
        full_name: name,
        event_name: event_name,
        app_url: app_url
    };
    $.ajax({
        type: 'POST',
        url: `${$c889b34800d09a44$var$API_URL}/attendee/update-by-kiosk`,
        data: JSON.stringify(data),
        dataType: 'json',
        success (resp) {
            callback(resp.result);
        }
    });
}
function $c889b34800d09a44$export$825ac59bb370e6d4(attendee_uid_list, private_id, { apiUrl: apiUrl = $c889b34800d09a44$var$API_URL, callback: callback = ()=>{} } = {}) {
    const data = {
        attendee_uid_list: attendee_uid_list,
        event_private_api_key: private_id
    };
    $.ajax({
        type: 'POST',
        url: `${apiUrl}/attendee/check-and-group-uid-list`,
        data: JSON.stringify(data),
        dataType: 'json',
        success (resp) {
            callback(resp.result);
        }
    });
}
// eslint-disable-next-line no-unused-vars
function $c889b34800d09a44$var$scanAgain() {
    $('#error').html('');
    $('#scanCardInput').val('');
    $('#scanCardInput').focus();
}
async function $c889b34800d09a44$var$captureLoginEvent(attId, event, eventName = 'Login', email = '', name = '') {
    await (0, $hMTg2.captureEvents)({
        EventSource: 'OldWebApp',
        EventName: eventName,
        EventType: 'info',
        EventCode: event.name,
        OrganisationId: event.organisation_id,
        EventId: event.id,
        EventFullName: event.full_name,
        AttendeeUid: attId,
        Email: email,
        UserFullName: name,
        Count: '1'
    });
}
function $c889b34800d09a44$var$openAlbum(attId, event) {
    window.location.href = $c889b34800d09a44$var$redirectLink(attId, event);
}
function $c889b34800d09a44$var$redirectLink(attId, event, isFromEmail = false) {
    const opts = event.opts && JSON.parse(event.opts);
    if (opts.enabledRedirectToWebapp) {
        let link = `${"https://storibox.com/webapps/"}?eName=${event.name}&uId=${attId}`;
        if (isFromEmail) link += '&fr=false';
        return link;
    }
    let eventLink = `${$c889b34800d09a44$var$OLD_WEBAPP}?attId=${attId}`;
    if ($c889b34800d09a44$var$PAYPAL_ACTIVE) eventLink += '&attType=evSB2';
    return eventLink;
}
// eslint-disable-next-line no-extend-native
String.prototype.replaceAll = function(search, replacement) {
    const target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};
function $c889b34800d09a44$export$64f8ac76bc45ea2d(attId, eventPrivateApiKey, partialUnlockTag = '') {
    $c889b34800d09a44$export$ebff25aed703e461('Loading...');
    $c889b34800d09a44$var$attendeeValidation({
        attendeeUid: attId,
        eventPrivateApiKey: eventPrivateApiKey
    }, (resp)=>{
        if (resp.status === 'ok') {
            if (resp.result) $c889b34800d09a44$var$getEvent(attId, (eventResp)=>{
                $c889b34800d09a44$export$ebff25aed703e461('');
                if (eventResp.status === 'ok') {
                    if (eventResp.result && eventResp.result.dataList.length > 0) {
                        const eventParams = eventResp.result.dataList[0];
                        const eventName = eventParams.name;
                        if (partialUnlockTag?.length > 0) $c889b34800d09a44$var$partialUnlock(attId, eventParams.private_api_key, partialUnlockTag, ()=>{});
                        if (eventParams.opts) {
                            const eventOptions = JSON.parse(eventParams.opts);
                            if (eventOptions && eventOptions.enableEmailCollect === 1) {
                                if (resp.result.email_address === 'null' || resp.result.email_address === null) {
                                    $('.att-email').slideDown();
                                    $('#scanCardInput').removeClass('scan-card');
                                    $('#scanCardAct').hide();
                                    $c889b34800d09a44$export$d5fafd96da807b8f('saveAttEmail').onclick = function() {
                                        const attendeeEmailVal = $c889b34800d09a44$export$d5fafd96da807b8f('attendeeEmail').value;
                                        const name = $c889b34800d09a44$export$d5fafd96da807b8f('attendeeName').value;
                                        if (attendeeEmailVal === '') captureAndRedirect(eventParams);
                                        else if (!$c889b34800d09a44$var$isEmail(attendeeEmailVal, false)) $c889b34800d09a44$export$ebff25aed703e461($c889b34800d09a44$export$69d25b90d0002cf3.valid_email);
                                        else {
                                            $('.att-email').slideUp();
                                            $c889b34800d09a44$var$captureLoginEvent(attId, eventParams, 'LoginUpdate', attendeeEmailVal, name);
                                            $c889b34800d09a44$var$updateAttendee(attId, attendeeEmailVal, name, eventName, $c889b34800d09a44$var$redirectLink(attId, eventParams, true), ()=>{
                                                $c889b34800d09a44$var$openAlbum(attId, eventParams);
                                            });
                                        }
                                    };
                                } else captureAndRedirect(eventParams);
                            } else captureAndRedirect(eventParams);
                        }
                    } else $c889b34800d09a44$export$ebff25aed703e461($c889b34800d09a44$export$69d25b90d0002cf3.empty_album);
                }
            });
            else $c889b34800d09a44$export$ebff25aed703e461($c889b34800d09a44$export$69d25b90d0002cf3.empty_album);
        } else $c889b34800d09a44$export$ebff25aed703e461($c889b34800d09a44$export$69d25b90d0002cf3.valid_att_code);
        function captureAndRedirect(eventParams) {
            return $c889b34800d09a44$var$captureLoginEvent(attId, eventParams).then(()=>$c889b34800d09a44$var$openAlbum(attId, eventParams));
        }
    });
}
function $c889b34800d09a44$export$ebff25aed703e461(txt) {
    $c889b34800d09a44$export$d5fafd96da807b8f('msgCont').innerHTML = txt;
}


$43d0305348800bf2$var$redirectToWebapp();
const $43d0305348800bf2$var$scanCardInput = (0, $c889b34800d09a44$export$d5fafd96da807b8f)('scanCardInput');
const $43d0305348800bf2$var$scanCardAct = (0, $c889b34800d09a44$export$d5fafd96da807b8f)('scanCardAct');
const $43d0305348800bf2$var$attId = (0, $c889b34800d09a44$export$34c5a9262f934fa5)('attId');
const $43d0305348800bf2$var$partialUnlockTag = (0, $c889b34800d09a44$export$34c5a9262f934fa5)('u');
const $43d0305348800bf2$var$eventPrivateApiKey = (0, $c889b34800d09a44$export$34c5a9262f934fa5)('pvId');
if ($43d0305348800bf2$var$attId) $43d0305348800bf2$var$scanCardInput.value = $43d0305348800bf2$var$attId;
function $43d0305348800bf2$var$isValid(code) {
    return code.length > 4 && code.length <= 32;
}
function $43d0305348800bf2$var$normalizeCode(code) {
    return code.replaceAll(' ', '');
}
function $43d0305348800bf2$var$handler() {
    if ($43d0305348800bf2$var$isValid($43d0305348800bf2$var$scanCardInput.value)) (0, $c889b34800d09a44$export$64f8ac76bc45ea2d)($43d0305348800bf2$var$normalizeCode($43d0305348800bf2$var$scanCardInput.value), $43d0305348800bf2$var$eventPrivateApiKey, $43d0305348800bf2$var$partialUnlockTag);
    else (0, $c889b34800d09a44$export$ebff25aed703e461)((0, $c889b34800d09a44$export$69d25b90d0002cf3).valid_att_code);
}
$43d0305348800bf2$var$scanCardAct.addEventListener('click', $43d0305348800bf2$var$handler);
$43d0305348800bf2$var$scanCardInput.addEventListener('keyup', (event)=>{
    if (event.keyCode === 13) {
        event.preventDefault();
        $43d0305348800bf2$var$handler();
    }
});
/**
 * Redirect to the webapp when we have the url like this
 * https://storibox.com/?wr=wemn,0,JXFQ-TWPR-4323
 */ function $43d0305348800bf2$var$redirectToWebapp() {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('wr')) {
        const wr = searchParams.get('wr');
        const [eventName, rawFr, attendeeId] = wr.split(',');
        const fr = rawFr === '1';
        window.location.replace(`${"https://storibox.com/webapps/"}?eName=${eventName}&uId=${attendeeId}&fr=${fr}`);
    }
}


//# sourceMappingURL=storibox.7367a32f.js.map
